module.exports = __webpack_public_path__ + "img/whiteBalloneHorizont.26f7c448.png";